import { ListItem, styled } from '@mui/material';

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  paddingLeft: theme.convert.pxToRem(40),
  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.convert.pxToRem(46),
  },
}));
